import React, { Component } from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import './CompetitorsAnalysisSuccess.css';
import ResultsTable from './ResultsTable/ResultsTable';
import jsPDF from 'jspdf';
import rasterizeHTML from 'rasterizehtml';

class CompetitorsAnalysisSuccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.competitiveAnalysis.addCompetitorsGroupsData !== nextProps.competitiveAnalysis.addCompetitorsGroupsData) {
            let body = {
                projectId: this.props.projectId,
                type: 'competitors'
            }
            this.props.getCompetitorsGroups(body);

        }
    }
    addResults = (data, key) => {
        let dataArr = [];
        if (key === 'actual&direct') {
            data.map((item, index) => {
                if (item.type === "actual" && item.indirect === "direct") {
                    dataArr.push(`<li key=${index} style='background-image: linear-gradient( white,#F1F1F1 );padding: .7em 15px;display: block;border: 1px solid #ccc;font-weight: bold;color: #222;text-shadow: 0 1px 0 #fff;border-radius: 5px;'>${item.competitorName}</li>`)
                }
            })
            return dataArr
        }
        if(key === 'actual&Indirect'){
            data.map((item, index) => {
                if (item.type === "actual" && item.indirect === "indirect") {
                    dataArr.push(`<li key=${index} style='background-image: linear-gradient( white,#F1F1F1 );padding: .7em 15px;display: block;border: 1px solid #ccc;font-weight: bold;color: #222;text-shadow: 0 1px 0 #fff;border-radius: 5px;'>${item.competitorName}</li>`)
                }
            })
            return dataArr
        }
        if(key === 'actual&complement'){
            data.map((item, index) => {
                if (item.type === "actual" && item.indirect === "complement") {
                    dataArr.push(`<li key=${index} style='background-image: linear-gradient( white,#F1F1F1 );padding: .7em 15px;display: block;border: 1px solid #ccc;font-weight: bold;color: #222;text-shadow: 0 1px 0 #fff;border-radius: 5px;'>${item.competitorName}</li>`)
                }
            })
            return dataArr
        }
        if (key === 'potential&direct') {
            data.map((item, index) => {
                if (item.type === "potential" && item.indirect === "direct") {
                    dataArr.push(`<li key=${index} style='background-image: linear-gradient( white,#F1F1F1 );padding: .7em 15px;display: block;border: 1px solid #ccc;font-weight: bold;color: #222;text-shadow: 0 1px 0 #fff;border-radius: 5px;'>${item.competitorName}</li>`)
                }
            })
            return dataArr
        }
        if(key === 'potential&Indirect'){
            data.map((item, index) => {
                if (item.type === "potential" && item.indirect === "indirect") {
                    dataArr.push(`<li key=${index} style='background-image: linear-gradient( white,#F1F1F1 );padding: .7em 15px;display: block;border: 1px solid #ccc;font-weight: bold;color: #222;text-shadow: 0 1px 0 #fff;border-radius: 5px;'>${item.competitorName}</li>`)
                }
            })
            return dataArr
        }
        if(key === 'potential&complement'){
            data.map((item, index) => {
                if (item.type === "potential" && item.indirect === "complement") {
                    dataArr.push(`<li key=${index} style='background-image: linear-gradient( white,#F1F1F1 );padding: .7em 15px;display: block;border: 1px solid #ccc;font-weight: bold;color: #222;text-shadow: 0 1px 0 #fff;border-radius: 5px;'>${item.competitorName}</li>`)
                }
            })
            return dataArr
        }
    }
    printDocument = (e) => {
        e.preventDefault();
        const canvas = document.createElement('canvas');
        canvas.height = 1000;
        canvas.width = 1500;
        // canvas.textAlign = "center";

            let html = `
            <div style='padding: 20px 0px 0px 30px'>
            <h2 style='font-size: 18px; color: #333333; margin: 0px 0px 0px 0px'>Results</h2>

            <br/>
            <table cellSpacing="0" className="resultsTable" style='width: 700px; outline: none; border: none;border-collapse: separate'>
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th style='text-align: center'>Direct</th>
                        <th style='text-align: center'>Indirect</th>
                        <th style='text-align: center'>Complement</th>
                    </tr>
                </thead>
                <tbody style='outline: none;border: none'>
                    <tr style='outline: none;border: none;'>
                        <td align="right" style='font-weight: bold;width: 10%; padding-right: 5px'>Actual</td>
                        <td valign="top" style='width: 25%;empty-cells: show;border-collapse: collapse;border: 1px solid #ddd;border-radius: 6px;padding: 7px'>
                            <ul style='vertical-align: middle; display: block;font-size: 13px;margin: 1em 0;list-style: none;padding: 0;border-radius: .6em'>
                                ${this.addResults(this.props.competitiveAnalysis.competitorsGroupsData.Items[0].competitors, 'actual&direct')}
                            </ul>
                        </td>
                        <td valign="top" style='width: 25%;empty-cells: show;border-collapse: collapse;border: 1px solid #ddd;border-radius: 6px;padding: 7px'>
                            <ul style='vertical-align: middle;display: block;font-size: 13px;margin: 1em 0;list-style: none;padding: 0;border-radius: .6em'>
                              ${this.addResults(this.props.competitiveAnalysis.competitorsGroupsData.Items[0].competitors, 'actual&Indirect')}
                            </ul>
                        </td>
                        <td valign="top" style='width: 25%;empty-cells: show;border-collapse: collapse;border: 1px solid #ddd;border-radius: 6px;padding: 7px'>
                            <ul style='vertical-align: middle;display: block;font-size: 13px;margin: 1em 0;list-style: none;padding: 0;border-radius: .6em'>
                                ${this.addResults(this.props.competitiveAnalysis.competitorsGroupsData.Items[0].competitors, 'actual&complement')}
                            </ul>
                        </td>
                    </tr>
                    <tr style='outline: none;border: none;'>
                        <td align="right" style='font-weight: bold;width: 10%; padding-right: 5px'>Potential</td>
                        <td valign="top" style='width: 25%;empty-cells: show;border-collapse: collapse;border: 1px solid #ddd;border-radius: 6px;padding: 7px'>
                            <ul style='vertical-align: middle;display: block;font-size: 13px;margin: 1em 0;list-style: none;padding: 0;border-radius: .6em'>
                                ${this.addResults(this.props.competitiveAnalysis.competitorsGroupsData.Items[0].competitors, 'potential&direct')}
                            </ul>
                        </td>
                        <td valign="top" style='width: 25%;empty-cells: show;border-collapse: collapse;border: 1px solid #ddd;border-radius: 6px;padding: 7px'>
                            <ul style='vertical-align: middle;display: block;font-size: 13px;margin: 1em 0;list-style: none;padding: 0;border-radius: .6em'>
                                ${this.addResults(this.props.competitiveAnalysis.competitorsGroupsData.Items[0].competitors, 'potential&Indirect')}
                            </ul>
                        </td>
                        <td valign="top" style='width: 25%;empty-cells: show;border-collapse: collapse;border: 1px solid #ddd;border-radius: 6px;padding: 7px'>
                            <ul style='vertical-align: middle;display: block;font-size: 13px;margin: 1em 0;list-style: none;padding: 0;border-radius: .6em'>
                                ${this.addResults(this.props.competitiveAnalysis.competitorsGroupsData.Items[0].competitors, 'potential&complement')}
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
            `;
            rasterizeHTML.drawHTML(html, canvas).then((renderResult) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'pt', 'a4');
            pdf.addImage(imgData, 'JPEG', 0, 0);
            pdf.save('competitive_analysis.pdf');
        });
    }
    printPage = () => {
        let html = `
        <div style='padding: 20px 0px 0px 30px'>
        <h2 style='font-size: 18px; color: #333333; margin: 0px 0px 0px 0px'>Results</h2>

        <br/>
        <table cellSpacing="0" className="resultsTable" style='width: 700px; outline: none; border: none;border-collapse: separate'>
            <thead>
                <tr>
                    <th>&nbsp;</th>
                    <th style='text-align: center'>Direct</th>
                    <th style='text-align: center'>Indirect</th>
                    <th style='text-align: center'>Complement</th>
                </tr>
            </thead>
            <tbody style='outline: none;border: none'>
                <tr style='outline: none;border: none;'>
                    <td align="right" style='font-weight: bold;width: 10%; padding-right: 5px'>Actual</td>
                    <td valign="top" style='width: 25%;empty-cells: show;border-collapse: collapse;border: 1px solid #ddd;border-radius: 6px;padding: 7px'>
                        <ul style='vertical-align: middle; display: block;font-size: 13px;margin: 1em 0;list-style: none;padding: 0;border-radius: .6em'>
                            ${this.addResults(this.props.competitiveAnalysis.competitorsGroupsData.Items[0].competitors, 'actual&direct')}
                        </ul>
                    </td>
                    <td valign="top" style='width: 25%;empty-cells: show;border-collapse: collapse;border: 1px solid #ddd;border-radius: 6px;padding: 7px'>
                        <ul style='vertical-align: middle;display: block;font-size: 13px;margin: 1em 0;list-style: none;padding: 0;border-radius: .6em'>
                          ${this.addResults(this.props.competitiveAnalysis.competitorsGroupsData.Items[0].competitors, 'actual&Indirect')}
                        </ul>
                    </td>
                    <td valign="top" style='width: 25%;empty-cells: show;border-collapse: collapse;border: 1px solid #ddd;border-radius: 6px;padding: 7px'>
                        <ul style='vertical-align: middle;display: block;font-size: 13px;margin: 1em 0;list-style: none;padding: 0;border-radius: .6em'>
                            ${this.addResults(this.props.competitiveAnalysis.competitorsGroupsData.Items[0].competitors, 'actual&complement')}
                        </ul>
                    </td>
                </tr>
                <tr style='outline: none;border: none;'>
                    <td align="right" style='font-weight: bold;width: 10%; padding-right: 5px'>Potential</td>
                    <td valign="top" style='width: 25%;empty-cells: show;border-collapse: collapse;border: 1px solid #ddd;border-radius: 6px;padding: 7px'>
                        <ul style='vertical-align: middle;display: block;font-size: 13px;margin: 1em 0;list-style: none;padding: 0;border-radius: .6em'>
                            ${this.addResults(this.props.competitiveAnalysis.competitorsGroupsData.Items[0].competitors, 'potential&direct')}
                        </ul>
                    </td>
                    <td valign="top" style='width: 25%;empty-cells: show;border-collapse: collapse;border: 1px solid #ddd;border-radius: 6px;padding: 7px'>
                        <ul style='vertical-align: middle;display: block;font-size: 13px;margin: 1em 0;list-style: none;padding: 0;border-radius: .6em'>
                            ${this.addResults(this.props.competitiveAnalysis.competitorsGroupsData.Items[0].competitors, 'potential&Indirect')}
                        </ul>
                    </td>
                    <td valign="top" style='width: 25%;empty-cells: show;border-collapse: collapse;border: 1px solid #ddd;border-radius: 6px;padding: 7px'>
                        <ul style='vertical-align: middle;display: block;font-size: 13px;margin: 1em 0;list-style: none;padding: 0;border-radius: .6em'>
                            ${this.addResults(this.props.competitiveAnalysis.competitorsGroupsData.Items[0].competitors, 'potential&complement')}
                        </ul>
                    </td>
                </tr>
            </tbody>
        </table>

    </div>
        `;
            let w=window.open();
            w.document.write(html);
            w.print();
            w.close();
    };
    downloadPDF = (e) => {
        this.printDocument(e);
    }
    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }
    onBackButton = () => {
        let body = {
            projectId: this.props.projectId,
            type: 'competitors'
        }
        this.props.getCompetitorsGroups(body);
        this.props.groupStateBack()
    }

    render() {

        return (
            <div className='customer-groups-content'>
                <div className='step-bar'>
                    <div className='step step-five arrow-step '>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-five arrow-step '>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-five arrow-step'>
                        <p>Step 3</p>
                    </div>
                    <div className='step step-five arrow-step'>
                        <p>Step 4</p>
                    </div>
                    <div className='step step-five arrow-step active-step'>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className="row">
                      <div className="col-sm-12">
                        <h5>COMPETITORS</h5>
                      </div>
                    </div>
                    {!this.props.competitiveAnalysis.competitorsGroupsFetching &&
                        <div className='row'>
                            <div className='col-xl-7 col-lg-8 col-md-10'>
                                <div className='card'>
                                    <div className='card-header'>
                                        <h5>Results</h5>
                                    </div>
                                    <div className='card-body'>
                                        <ResultsTable
                                            data={this.props.competitiveAnalysis.competitorsGroupsData}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-12'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <Link className='btn btn-success' to={'/segmentAttractiveness/'+this.props.projectId}> Next </Link>
                                        <Link to='/toolkit' className='btn btn-success'> Done </Link>
                                        <div className='btn empty-btn default' onClick={this.downloadPDF}>Save PDF</div>
                                        <div className='btn empty-btn default' onClick={this.printPage}>Print</div>
                                        <div onClick={this.onBackButton} className='btn empty-btn default'> Back </div>
                                    </div>
                                </div>
                            </div>
                        </div>}
                </div>
                {this.props.competitiveAnalysis.competitorsGroupsFetching &&
                    <div className='card'>
                        <div className="card-body">
                            {this.elementInfiniteLoad()}
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default (CompetitorsAnalysisSuccess);



// WEBPACK FOOTER //
// ./src/components/CompetitiveAnalysis/CompetitorsAnalysisSuccess/CompetitorsAnalysisSuccess.jsx